
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';

export default BaseCmsBlock.extend({
  name: 'DirectionsCompletedProjectsBlock',

  fetch: async function () {
    await this.getArticlesApi();
  },

  data: function () {
    return {
      articlesApi: [],
      isApi: this.externalData?.DirectionsCompletedProjectsBlock?.isApi || false,
    }
  },

  computed: {
    filteredArticles: function () {
      if (this.isApi) {
        return this.articlesApi
      }
      return [...(this.extras.articles || [])].splice(0, 3);
    },
    allLink: function () {
      const articleTag = this.values?.article_tags?.[0]?.value;
      if (articleTag) {
        return `/news?page=1&filter[tag_id]=${ articleTag }`
      }
      return `/news`
    }
  },

  methods: {
    getArticlesApi: async function () {
      if (!this.isApi && !this.externalData?.DirectionsCompletedProjectsBlock?.isApi) {
        return
      }

      const tags = this.externalData?.DirectionsCompletedProjectsBlock?.tags || [];
      if (!tags.length) {
        return
      }

      const exceptions = this.externalData?.DirectionsCompletedProjectsBlock?.exceptions || [];

      let filter = [];
      tags.map((tag) => {
        filter.push(`filter[tag_id][]=${tag}`);
      })
      let articles = await this.$api.agent.transport.get(`/articles?${filter.join('&')}&expand=tags&per-page=3`).then((res) => {
        return res.data
      }).catch((err) => {
        return []
      });
      articles = articles.filter((t) => !exceptions.includes(t.id))
      this.articlesApi = articles;
    },
  }
});
